export enum TaskNameEnum {
    missedVisit = 1,
    unassignedVisit = 2,
    visitNotStarted = 4,
    visitPendingQA = 8
}
